import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class TransferApiDataService {
   url = environment.url;
   constructor(private http: HttpClient){}

    //MASTER DATA
    public getMasterData(orgId: string, lob: string): Observable<any> {
      return this.http.get(`${this.url}store/getMasterData${orgId? `${orgId}?` : '?'}lob=${lob}`);
    }

    //POST
    public transfer(payload: any): Observable<any> {
      return this.http.post(`${this.url}store/createTransfer`, payload);
    }

    //GET ALL 3PLS LIST
    public getFullOrg(): Observable<any> {
        return this.http.get(`${this.url}threeplbydc`);
    }

    //GET LOB 3PLS LIST
    public getLobOrg(lob: any): Observable<any> {
        return this.http.get(`${this.url}threeplbydc?lob=${lob}`);
    }

    //GET SUPPLY LIST
    public getSupplies(): Observable<any> {
        return this.http.get(`${this.url}config/getSupplyConfigs`)
    }
}